<template>
    <section class="col s12">
        <div class="row" v-if="!temAcaoSelecionada">
            <div class="col s12">
                <p class="label-info-nao-encontrada">Ainda não foi selecionada a Ação para realização da inscrição!</p>
            </div>
        </div>

        <section v-else>
            <div class="row">
                <div class="col s12 blue-grey lighten-5">
                    <p v-if="modalidade == 'Projeto' || modalidade == 'Programa'">
                        <i class="material-icons blue-text text-darken-3 left">info</i>
                        <span style="font-weight: bold;">Informação!</span>
                        <span>De acordo com a modalidade da sua ação <b>({{ modalidade }})</b> você só poderá adicionar atividades para até </span>&nbsp;<b><span>{{ quantidadeMaximaDeMeses }} Mes(es).</span></b>
						<br>
						<span>{{msgCronogramaAtividades}}</span>
					</p>
					<p v-else>
                        <i class="material-icons red-text text-darken-3 left">info</i>
                        <span style="font-weight: bold;">Informação!</span>
                        <span>Item não pontuado, preencha o campo abaixo com a frase "NÃO SE APLICA".</span></b>
						
					</p>
					
                </div>
            </div>

            <div class="row">
                <div class="col s12">
                    <ul id="ul_cronograma_de_atividades">
                        <li v-for="(etapa, etapa_i) in cronogramaDeAtividades" :key="etapa_i">
                            <!--                            <div class="collapsible-header">-->
                            <!--                                <i class="material-icons">date_range</i>Tarefa {{ etapa.mes }}-->
                            <!--                            </div>-->

                            <!--                            <div class="collapsible-body">-->
                            <div class=" card-panel">
                                <!--                                        <input type="hidden" :name="`cronograma_mes[${etapa.mes}]`" v-model="etapa.mes">-->

                                <div class="row">
                                    <div class="input-field  col s12">
                                        <label :for="`cronograma_atividade[${etapa.mes}]`" class="active"
                                               style="font-size: 16px; font-weight: bold;     -webkit-transform: translateY(-14px) scale(0.8);">Descrição da tarefa
                                        </label>
                                        <br>

                                        <textarea style="width: 100%; min-height: 150px;"
                                                  :name="`cronograma_atividade[${etapa.mes}]`"
                                                  :id="`cronograma_atividade_${etapa.mes}`"
                                                  :disabled="allDisabled"
                                                  maxlength="500"
                                                  required
                                                  v-model="etapa.atividades"
                                                  cols="30" rows="10"
                                                  class="browser-default"></textarea>
                                        <span class="right" style="font-size: small;">{{
                                                !etapa.atividades ? 0 : etapa.atividades.length
                                                                                      }}/500</span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="input-field col s6">
                                        <label :for="`cronograma_inicio[${etapa.mes}]`" class="active"
                                               style="font-size: 16px; font-weight: bold;">Qual a data de ínicio da
                                                                                           tarefa?
                                        </label>
                                        <br>
                                        <input class="validate" id="inicio" type="date"
                                               :name="`cronograma_inicio[${etapa.mes}]`"
                                               :id="`cronograma_inicio[${etapa.mes}]`"
                                               v-model="etapa.start_date"
											   :disabled="allDisabled"
                                               :min="(new Date()).toISOString().substring(0, 10)"
                                               required>
                                    </div>
                                    <div class="input-field col s6">
                                        <label :for="`cronograma_duracao[${etapa.mes}]`" class="active"
                                               style="font-size: 16px; font-weight: bold;">Qual a duração em meses?
                                        </label>
                                        <br>
                                        <input class="validate" type="number" :name="`cronograma_duracao[${etapa.mes}]`"
                                               :id="`cronograma_duracao[${etapa.mes}]`"
                                               v-model="etapa.mes"
                                               :max="quantidadeMaximaDeMeses"
											   :disabled="allDisabled"
                                               min="1"  required>
                                    </div>


                                </div>

                                <div class="row ">
                                    <div class="col s12">
                                        <button type="button"
                                                class="btn-small waves-effect waves-light grey darken-2"
                                                @click="removeUmaAtividade(etapa_i)"
                                                :disabled="allDisabled">
                                            <i class="material-icons left">delete</i>
                                            Remover tarefa
                                        </button>
                                    </div>

                                </div>
                            </div>

                            <!--                            </div>-->
                        </li>
                    </ul>
                </div>
            </div>

            <button type="button"
                    class="btn-small waves-effect waves-light blue lighten-1"
                    :disabled="allDisabled "
                    @click.stop="adicionaUmaNovaAtividade">
                <i class="material-icons left">add</i>
                Adicionar
            </button>
        </section>

        <Resultado_avaliacoes_itens_acao v-if="avaliacoes"
                                         :avaliacoes="avaliacoes"
                                         campo-referente-na-inscricao="cronograma_de_atividades"></Resultado_avaliacoes_itens_acao>

    </section>
</template>

<script>
import Resultado_avaliacoes_itens_acao from "./avaliacoes_resultado/resultado_avaliacoes_itens_acao";

export default {
    name: "cronograma_atividades",
    components: {Resultado_avaliacoes_itens_acao},
    props: {
        temAcaoSelecionada: {
            type: Boolean,
            default: false
        },
        modalidade: {
            type: String,
            default: null
        },
        quantidadeMaximaDeMeses: {
            type: Number,
            default: 1
        },
        pCronogramaDeAtividades: {
            type: Array,
            default: () => { return [] }
        },
        allDisabled: {
            type: Boolean,
            default: false,
        },
		msgCronogramaAtividades: {
            type: String,
            default: null,
            required: true
        },
        pAvaliacoes: {
            type: Array|null,
            default: null,
        }
    },
    data() {
        return {
            cronogramaDeAtividades: this.pCronogramaDeAtividades,

            componenteCronogramaDeAtividades: null,

            avaliacoes: this.pAvaliacoes,
        }
    },
    watch: {
        pCronogramaDeAtividades: {
            deep: true,
            handler(newValue){
                this.cronogramaDeAtividades = newValue
            }
        },
        cronogramaDeAtividades: {
            deep: true,
            handler(newValue){
                this.$emit('update:pCronogramaDeAtividades', newValue)
            }
        },
        temAcaoSelecionada(newValue){
            if(newValue && this.cronogramaDeAtividades.length === 0)
                this.adicionaUmaNovaAtividade()
        },
    },
    methods: {
        adicionaUmaNovaAtividade() {
            if(this.temAcaoSelecionada ){
                const mes = this.cronogramaDeAtividades.length + 1;

                this.cronogramaDeAtividades.push({
                    id: null,
                    mes: 1,
                    atividades: null,
                    start_date: null,
                })
            }
        },
        removeUmaAtividade(indiceParaRemocao){
            this.cronogramaDeAtividades.splice(indiceParaRemocao, 1)
        },

        montaComponenteDoCronogramaDeAtividades(){
            const elemento = $('#ul_cronograma_de_atividades')

            elemento.collapsible()

            if(elemento)
                this.componenteCronogramaDeAtividades = M.Collapsible.getInstance(elemento.get()[0])

            this.abreJanelaEspecificaDoCronograma()
        },

        destroiComponenteDoCronogramaDeAtividades(){
            if(!this.componenteCronogramaDeAtividades)
                return false

            this.componenteCronogramaDeAtividades.destroy()
        },

        abreJanelaEspecificaDoCronograma(janela = 0){
            if(!this.componenteCronogramaDeAtividades)
                return false
			//this.componenteCronogramaDeAtividades.open()
        }
    },
    async mounted() {
        if(this.cronogramaDeAtividades.length === 0)
            await this.adicionaUmaNovaAtividade()

        await this.montaComponenteDoCronogramaDeAtividades()
    },
    updated() {
        if(!this.componenteCronogramaDeAtividades)
            this.montaComponenteDoCronogramaDeAtividades()
    },
    beforeDestroy() {
        this.destroiComponenteDoCronogramaDeAtividades()
    }

}
</script>

<style scoped>

</style>
